import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "send-icon",
  role: "img",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M5.63866 3.44158C3.97859 2.67169 2.27113 4.3082 2.87379 5.99517L5.01679 11.9971L2.87393 18.0054C2.27058 19.6923 3.97949 21.3278 5.63894 20.5582L20.0677 13.8593C21.6449 13.1276 21.6449 10.8703 20.0677 10.1386L5.63866 3.44158ZM4.28638 5.49059C4.11525 5.0117 4.59754 4.61241 5.00737 4.80227L18.8992 11.25H6.34277L4.28638 5.49059ZM6.34083 12.75L4.28653 18.5099C4.11588 18.987 4.59702 19.388 5.00757 19.1976L18.8951 12.75H6.34083Z"
    }, null, -1)
  ])))
}
export default { render: render }